var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{staticClass:"info",attrs:{"id":_vm.name,"name":_vm.name,"title":_vm.title,"alt":_vm.title,"src":require("@/assets/imported-icons/ic_fluent_info_20_regular.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }